import { siteConfig } from '../config/site';
import { enableMoonbaseGoogleAnalytics } from './moonbase';

const CONSENT_KEY = 'wavecraft-analytics-consent';

export type AnalyticsConsent = 'accepted' | 'declined' | null;

export function getAnalyticsConsent(): AnalyticsConsent {
  if (!siteConfig.analytics.googleAnalyticsId) return 'declined';
  const value = window.localStorage.getItem(CONSENT_KEY);
  return value === 'accepted' || value === 'declined' ? value : null;
}

export function setAnalyticsConsent(value: Exclude<AnalyticsConsent, null>): void {
  window.localStorage.setItem(CONSENT_KEY, value);
  if (value === 'accepted') initializeGoogleAnalytics();
}

export function initializeGoogleAnalytics(): void {
  const measurementId = siteConfig.analytics.googleAnalyticsId;
  if (!measurementId || getAnalyticsConsent() !== 'accepted') return;
  if (document.querySelector('script[data-wavecraft-ga]')) {
    enableMoonbaseGoogleAnalytics(measurementId);
    return;
  }

  window.dataLayer = window.dataLayer ?? [];
  window.gtag = (...args: unknown[]) => window.dataLayer?.push(args);
  window.gtag('js', new Date());
  window.gtag('config', measurementId, { anonymize_ip: true });

  const script = document.createElement('script');
  script.async = true;
  script.dataset.wavecraftGa = 'true';
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  script.addEventListener('load', () => enableMoonbaseGoogleAnalytics(measurementId), {
    once: true,
  });
  document.head.appendChild(script);
}
